import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'uxd-design-system-components';
import './LearnMoreCards.scss';
import LearnMoreLink from '~types/LearnMoreLink';
import LearnMoreCardsProps from '~types/components/LearnMoreCardsProps';
// eslint-disable-next-line import/no-unresolved
import * as images from 'url:../../assets/images/*.png';

const LearnMoreCards = (props: LearnMoreCardsProps) => {
  const {
    valueStatement,
    valueStatementId,
    learnMoreContent,
    learnMoreLinks,
    displayLearnMoreContent,
    setDisplayLearnMoreContent,
    rank,
  } = props;

  useEffect(() => {}, [document.getElementsByClassName('learnMoreCard')]);

  useEffect(() => {
    document.body.classList.add('verification-multi-modal');
    return () => {
      document.body.classList.remove('verification-multi-modal');
    };
  }, []);

  return (
    <Dialog
      title=""
      open={displayLearnMoreContent}
      buttons={[]}
      className="learnMoreCard"
      onRequestClose={() => {
        setDisplayLearnMoreContent(false);
      }}
    >
      <div className="value-rank">
        <h4>{rank}</h4>
      </div>
      <div className="value-image">
        <img src={images[`${valueStatementId}`]} alt="" role="presentation" />
      </div>
      <div className="value-statement">{valueStatement}</div>
      <div className="learn-more-content">
        <p>{learnMoreContent}</p>
      </div>
      <div className="learn-more-links-button">
        {learnMoreLinks ? (
          <ul>
            {learnMoreLinks.map((link: LearnMoreLink) => (
              <li key={link.learnMoreLinkUrl}>
                <a
                  href={link.learnMoreLinkUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {link.learnMoreLinkText}
                </a>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </Dialog>
  );
};

LearnMoreCards.defaultProps = {
  learnMoreContent: null,
  learnMoreLinks: null,
  displayLearnMoreContent: false,
  setDisplayLearnMoreContent: null,
  rank: null,
};

LearnMoreCards.propTypes = {
  valueStatement: PropTypes.string.isRequired,
  valueStatementId: PropTypes.number.isRequired,
  learnMoreContent: PropTypes.string,
  learnMoreLinks: PropTypes.arrayOf(PropTypes.object),
  displayLearnMoreContent: PropTypes.bool,
  setDisplayLearnMoreContent: PropTypes.func,
  rank: PropTypes.number,
};

export default LearnMoreCards;
